import { combineReducers } from 'redux';
import { fetchStatistics, fetchCommonStatistics } from '../sagas/statistics/actions';

const common = (state = {}, action) => {
  if (action.type === fetchCommonStatistics.done.type) {
    return action.payload.result;
  }

  return state;
};

const isStatisticsLoaded = (state = false, action) => {
  if (action.type === fetchStatistics.started.type) {
    return false;
  }
  if (action.type === fetchStatistics.done.type) {
    return true;
  }

  return state;
};

const statistics = (state = [], action) => {
  if (action.type === fetchStatistics.done.type) {
    return state.concat({
      ...action.payload.result,
      deviceId: action.payload.params.params.Devices[0],
    });
  }

  return state;
};

export default combineReducers({
  isStatisticsLoaded,
  statistics,
  common,
});



// WEBPACK FOOTER //
// ./src/reducers/statistics.js